import styled from "@emotion/styled";
import { space } from "@smartsheet/design-tokens";
import { memo } from "react";
import { TypeRampV2 } from "../../../typography";
import { DatePickerDayBox } from "./DatePickerDayBox";
import { datePickerTheme } from "./datePickerTheme";

// These don't change, so we can memoize them.
export const DatePickerDayOfWeek = /*#__PURE__*/memo(styled(DatePickerDayBox)`
        color: ${_ref => {
  let {
    themeMode
  } = _ref;
  return datePickerTheme.dayLabelColor(themeMode);
}};
        font-size: ${_ref2 => {
  let {
    themeMode
  } = _ref2;
  return datePickerTheme.dayLabelFontSize(themeMode);
}};
        height: ${space.space60};
    `.withComponent(TypeRampV2));
DatePickerDayOfWeek.displayName = "DatePickerDayOfWeek";
//# sourceMappingURL=DatePickerDayOfWeek.js.map